// Normalize i18n language to the primary tag that matches the keys stored in
// Mongo (products.translations, brands.translations, categories.translations,
// blog_posts.translations, gallery.translations). i18next may expose the full
// BCP-47 tag like "ru-RU" or "sk-SK" (from the browser detector), but the
// translations dictionary uses only two-letter codes ("ru", "sk", ...).
// Without this normalization the lookup silently falls back to Slovak on
// any browser whose navigator.language carries a region suffix.
export const getUiLang = (i18n) => {
  const raw = i18n?.resolvedLanguage || i18n?.language || 'sk';
  return String(raw).toLowerCase().split('-')[0];
};
